import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-2"
}
const _hoisted_2 = { class: "flex flex-col h-full w-[25rem] items-center justify-center text-light-black py-14 mb-14" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl font-black text-white text-center" }, "Login as", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1)
const _hoisted_5 = { class: "w-full align-middle mt-5 flex flex-col gap-6 bg-white shadow-base h-fit rounded-t-3xl px-5 py-10" }
const _hoisted_6 = {
  key: 2,
  class: "flex flex-col gap-5"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "bg-light-gray-100 w-full flex justify-center items-center py-5 rounded-b-3xl" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode("Don’t have an account? "),
    /*#__PURE__*/_createElementVNode("a", {
      class: "text-primary-violet font-bold",
      href: "/signup"
    }, "Sign up")
  ])
], -1)

import { computed } from "vue"
  import { useRouter, useRoute } from "vue-router"
  import { IonButton, IonPage, IonContent } from "@ionic/vue"
  import WbTemplate from "@/components/account-creation/template.vue"
  import LoginPage from "@/components/account-creation/LoginPage.vue"
  import LoginEmailPage from "@/components/account-creation/LoginEmail.vue"
  import Menubar from "@/components/menuBar.vue"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'LoginAs',
  setup(__props) {

  const router = useRouter()
  const route = useRoute()

  const view = computed(() => {
    if (
      (router.currentRoute.value.query.as && router.currentRoute.value.query.as === "professional") ||
      (router.currentRoute.value.query.as && router.currentRoute.value.query.as === "employee" && router.currentRoute.value.query.status && router.currentRoute.value.query.status === "active")
    )
      return "formView"
    else if (router.currentRoute.value.query.as && router.currentRoute.value.query.as === "employee" && !router.currentRoute.value.query.status) return "repView"
    return "choiceView"
  })

  const reroute = (path: string) => {
    router.push(path)
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(route).fullPath === '/login')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(Menubar)
        ]))
      : _createCommentVNode("", true),
    _createVNode(WbTemplate, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            (_unref(view) === 'formView')
              ? (_openBlock(), _createBlock(LoginPage, { key: 0 }))
              : (_unref(view) === 'repView')
                ? (_openBlock(), _createBlock(LoginEmailPage, { key: 1 }))
                : (_unref(view) === 'choiceView')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_unref(IonButton), {
                        expand: "block",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (reroute('/login?as=employee')))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Company Representative")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonButton), {
                        expand: "block",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (reroute('/login?as=professional')))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Professional / Jobseeker")
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
          ]),
          _hoisted_7
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})